/* eslint-disable prettier/prettier */

// @mui material components
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import "rc-tree/assets/index.css";
import Tree, { TreeNode } from "rc-tree";
import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ActualizarUsuario,
  getPermisosUsurios,
  ResetearContrasena,
} from "store/usuarios/usuariosActions";
import { InformacionInicialRoles } from "store/roles/rolesActions";
import { InformacionInicialCatalogos } from "store/catalogos/catalogosActions";
import { map, filter, find } from "lodash";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import toast from "react-hot-toast";
import { store } from "store/store";
import ModalContent from "components/ModalContent";
import MDTypography from "components/MDTypography";

export default function ModificarUsuario() {
  const usuario = store.getState().login.usuario;
  const { state } = useLocation();
  const navigate = useNavigate();
  const { grupos, permisos, rolesUsuarios } = useSelector((state) => state.roles);
  const { hospitales } = useSelector((state) => state.catalogos);
  const [nombre, setNombre] = useState(state.nombre ? state.nombre : null);
  const [apellioPaterno, setapellioPaterno] = useState(
    state.apellioPaterno ? state.apellioPaterno : null
  );
  const [apellioMaterno, setapellioMaterno] = useState(
    state.apellioMaterno ? state.apellioMaterno : null
  );
  const [idRolUsuario, setIdRolUsuario] = useState(state.idRolUsuario ? state.idRolUsuario : null);
  const [rolUsuario, setrolUsuario] = useState(state.rolUsuario ? state.rolUsuario : "");
  const [idHospital, setIdHospital] = useState(state.idHospital ? state.idHospital : 0);
  const [esAdmin, setEsAdmin] = useState(state.rolUsuario == "Administración");
  const [correo, setcorreo] = useState(state.correo ? state.correo : null);
  const [celular, setcelular] = useState(state.celular ? state.celular : null);
  const [username, setusername] = useState(state.username ? state.username : null);

  const [invalid_nombre, setInvalidNombre] = useState(false);
  const [invalid_apellioPaterno, setInvalidApellioPaterno] = useState(false);
  const [invalid_apellioMaterno, setInvalidApellioMaterno] = useState(false);
  const [invalid_rolUsuario, setInvalidRolUsuario] = useState(false);
  const [invalid_hospital, setInvalidHospital] = useState(false);
  const [invalid_correo, setInvalidCorreo] = useState(false);
  const [invalid_celular, setInvalidCelular] = useState(false);
  const [invalid_username, setInvalidUsername] = useState(false);

  const [permisosAc, setPermisos] = useState([]);

  const [mostarModalConfirm, setMostarModalConfirm] = useState(false);
  const [openmodalRestablecer, setopenmodalRestablecer] = useState(false);

  const [rolElegido, setRolElegido] = useState(null);

  const dispatch = useDispatch();
  useEffect(() => {
    InformacionInicialRoles(dispatch);
    InformacionInicialCatalogos(dispatch);
    consultarPermisos();
  }, []);

  const rolesUsuariosMostrar = useMemo(() => {
    return rolesUsuarios.filter((obj) => obj.activo != false);
  }, [rolesUsuarios]);

  const hospitalesMostrar = useMemo(() => {
    return hospitales.filter((obj) => obj.activo != false);
  }, [hospitales]);

  const consultarPermisos = async () => {
    const res = await dispatch(getPermisosUsurios(state?.idUsuario));
    const idPermisos = res ? map(res.permisos, (item) => item.idPermiso.toString()) : [];
    setPermisos(idPermisos);
  };

  const EditarUsuario = async () => {
    if (!nombre) {
      toast.error("Ingresar nombre del usuario");
      setInvalidNombre(true);
      return false;
    }
    if (!apellioPaterno) {
      toast.error("Ingresar el apellido paterno del usuario");
      setInvalidApellioPaterno(true);
      return false;
    }
    if (!rolUsuario) {
      toast.error("Seleccione rol para el usuario");
      setInvalidRolUsuario(true);
      return false;
    }
    // if (rolUsuario.rolUsuario != "Administración" && !hospital) {
    //   toast.error("Seleccione un hospital para el usuario");
    //   setInvalidHospital(true);
    //   return false;
    // }
    if (!correo) {
      toast.error("Ingrese el correo electrónico del usuario");
      setInvalidCorreo(true);
      return false;
    }
    if (!celular) {
      toast.error("Ingrese el celular del usuario");
      setInvalidCelular(true);
      return false;
    }
    if (!username) {
      toast.error("Ingrese el username para el usuario");
      setInvalidUsername(true);
      return false;
    }

    const data = {
      idUsuario: state.idUsuario ? state.idUsuario : null,
      nombre: nombre,
      apellioPaterno: apellioPaterno,
      apellioMaterno: apellioMaterno,
      idRolUsuario: idRolUsuario,
      rolUsuario: rolUsuario,
      idHospital: idHospital,
      correo: correo,
      celular: celular,
      username: username,
      permisos: permisosAc,
      esAdmin: esAdmin,
      colorRol: state.colorRol ? state.colorRol : "#FFFFFF",
      firmaUsuario: "",
      idTipoUsuario: 3,
      cadenaPermisos: "",
      heredarPermisos: true,
      userId: usuario.idUsuario,
      activo: state.activo ? state.activo : false,
    };
    ActualizarUsuario(dispatch, data);
    navigate("/usuarios");
  };

  const ConfirmarCambioRol = () => {
    setrolUsuario(rolElegido.rolUsuario);
    setIdRolUsuario(rolElegido.idRolUsuario);
    const permisos = rolElegido.permisos
      ? map(rolElegido.permisos, (item) => item.idPermiso.toString())
      : [];
    setPermisos(permisos);
    if (rolElegido.rolUsuario == "Administración") {
      setEsAdmin(true);
      setIdHospital(0);
    } else {
      setEsAdmin(false);
    }
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={1} pb={3}>
          <Grid container>
            <Grid item xs={12}>
              <Card>
                <Grid item xs={12} md={12} lg={12}>
                  <MDBox mb={1.5} py={1} px={2} display="flex" justifyContent="space-between">
                    <Button
                      variant="contained"
                      startIcon={<Icon>arrow_back_ios_new</Icon>}
                      color="primary"
                      size="small"
                      style={{ textTransform: "inherit" }}
                      onClick={() => navigate("/usuarios")}
                    >
                      Regresar
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<Icon>send</Icon>}
                      color="primary"
                      size="small"
                      style={{ textTransform: "inherit" }}
                      onClick={() => EditarUsuario()}
                    >
                      Guardar
                    </Button>
                  </MDBox>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={5} lg={5}>
                    <MDBox py={3} px={2}>
                      <TextField
                        value={nombre}
                        onChange={(event) => {
                          setNombre(event.target.value);
                        }}
                        onFocus={() => {
                          setInvalidNombre(false);
                        }}
                        onBlur={() => {
                          if (!nombre) setInvalidNombre(true);
                        }}
                        error={invalid_nombre}
                        helperText={invalid_nombre && "Campo obligatorio*"}
                        label="Nombre"
                        variant="outlined"
                        style={{ width: "100%", marginBottom: "1.5rem" }}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        value={apellioPaterno}
                        onChange={(event) => {
                          setapellioPaterno(event.target.value);
                        }}
                        onFocus={() => {
                          setInvalidApellioPaterno(false);
                          if (!nombre) {
                            setInvalidNombre(true);
                          }
                        }}
                        onBlur={() => {
                          if (!apellioPaterno) setInvalidApellioPaterno(true);
                        }}
                        error={invalid_apellioPaterno}
                        helperText={invalid_apellioPaterno && "Campo obligatorio*"}
                        label="Apellido Paterno"
                        variant="outlined"
                        style={{ width: "100%", marginBottom: "1.5rem" }}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        value={apellioMaterno}
                        onChange={(event) => {
                          setapellioMaterno(event.target.value);
                        }}
                        error={false}
                        helperText=""
                        label="Apellido Materno"
                        variant="outlined"
                        style={{ width: "100%", marginBottom: "1.5rem" }}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      />
                      <Autocomplete
                        id="controlled-demo"
                        options={rolesUsuariosMostrar}
                        getOptionLabel={(option) => option.rolUsuario}
                        value={
                          find(rolesUsuarios, (opt) => opt.idRolUsuario === idRolUsuario) || null
                        }
                        onChange={(event, newValue) => {
                          if (newValue != null) {
                            setRolElegido(newValue);
                            setMostarModalConfirm(true);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Rol"
                            variant="outlined"
                            onFocus={() => {
                              setInvalidRolUsuario(false);
                              if (!nombre) {
                                setInvalidNombre(true);
                              }
                              if (!apellioPaterno) {
                                setInvalidApellioPaterno(true);
                              }
                            }}
                            onBlur={() => {
                              if (rolUsuario == null) setInvalidRolUsuario(true);
                            }}
                            error={invalid_rolUsuario}
                            helperText={invalid_rolUsuario && "Campo obligatorio*"}
                          />
                        )}
                        style={{ width: "100%", marginBottom: "1rem" }}
                        size="small"
                      />
                      {!esAdmin && (
                        <Autocomplete
                          id="controlled-demo"
                          options={hospitalesMostrar}
                          getOptionLabel={(option) => option.hospital}
                          value={find(hospitales, (opt) => opt.idHospital === idHospital) || null}
                          onChange={(event, newValue) => {
                            setIdHospital(newValue ? newValue.idHospital : 0);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Hospital"
                              variant="outlined"
                              onFocus={() => {
                                setInvalidHospital(false);
                                if (!nombre) {
                                  setInvalidNombre(true);
                                }
                                if (!apellioPaterno) {
                                  setInvalidApellioPaterno(true);
                                }
                                if (!rolUsuario) {
                                  setInvalidRolUsuario(true);
                                }
                              }}
                              error={false}
                            />
                          )}
                          style={{ width: "100%", marginBottom: "1rem" }}
                          size="small"
                        />
                      )}
                      <TextField
                        value={correo}
                        onChange={(event) => {
                          setcorreo(event.target.value);
                        }}
                        onFocus={() => {
                          setInvalidCorreo(false);
                          if (!nombre) {
                            setInvalidCorreo(true);
                          }
                          if (!apellioPaterno) {
                            setInvalidApellioPaterno(true);
                          }
                          if (!rolUsuario) {
                            setInvalidRolUsuario(true);
                          }
                          // if (!hospital) {
                          //   onChangeInvalid(true, "hospital");
                          // }
                        }}
                        onBlur={() => {
                          if (!correo) setInvalidCorreo(true);
                        }}
                        error={invalid_correo}
                        helperText={invalid_correo && "Campo obligatorio*"}
                        label="Correo"
                        variant="outlined"
                        style={{ width: "100%", marginBottom: "1.5rem" }}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        value={celular}
                        onChange={(event) => {
                          const soloNumeros = event.target.value.replace(/\D/g, ""); // Elimina letras
                          setcelular(soloNumeros);
                        }}
                        onFocus={() => {
                          setInvalidCelular(false);
                          if (!nombre) {
                            setInvalidCorreo(true);
                          }
                          if (!apellioPaterno) {
                            setInvalidApellioPaterno(true);
                          }
                          if (!rolUsuario) {
                            setInvalidRolUsuario(true);
                          }
                          // if (!hospital) {
                          //   onChangeInvalid(true, "hospital");
                          // }
                          if (!correo) {
                            setInvalidCorreo(true);
                          }
                        }}
                        onBlur={() => {
                          if (!celular) setInvalidCelular(true);
                        }}
                        inputProps={{
                          inputMode: "numeric", // Muestra teclado numérico en móviles
                          pattern: "[0-9]*", // Sugiere sólo números
                          maxLength: 10, // Límite de 10 caracteres
                        }}
                        error={invalid_celular}
                        helperText={invalid_celular && "Campo obligatorio*"}
                        label="Celular"
                        variant="outlined"
                        style={{ width: "100%", marginBottom: "1.5rem" }}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        value={username}
                        onChange={(event) => {
                          setusername(event.target.value);
                        }}
                        onFocus={() => {
                          setInvalidUsername(false);
                          if (!nombre) {
                            setInvalidCorreo(true);
                          }
                          if (!apellioPaterno) {
                            setInvalidApellioPaterno(true);
                          }
                          if (!rolUsuario) {
                            setInvalidRolUsuario(true);
                          }
                          // if (!hospital) {
                          //   onChangeInvalid(true, "hospital");
                          // }
                          if (!correo) {
                            setInvalidCorreo(true);
                          }
                          if (!celular) {
                            setInvalidCelular(true);
                          }
                        }}
                        onBlur={() => {
                          if (!username) setInvalidUsername(true);
                        }}
                        error={invalid_username}
                        helperText={invalid_username && "Campo obligatorio*"}
                        label="UserName"
                        variant="outlined"
                        style={{ width: "100%", marginBottom: "1.5rem" }}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                      />
                      <Button
                        variant="contained"
                        startIcon={<Icon>password</Icon>}
                        color="secondary"
                        size="small"
                        style={{ textTransform: "inherit" }}
                        onClick={() => {
                          setopenmodalRestablecer(true);
                        }}
                      >
                        Reenviar contraseña
                      </Button>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={7} lg={7}>
                    <MDBox mb={1.5}>
                      <Tree
                        showLine={false}
                        checkable={true}
                        defaultExpandAll={true}
                        checkedKeys={permisosAc}
                        onCheck={(checkedKeys) => {
                          const soloPermisosEspecificos = checkedKeys.filter(
                            (key) => /^[0-9]+$/.test(key) && key !== "0"
                          );
                          setPermisos(soloPermisosEspecificos);
                        }}
                        style={{ fontSize: 12, color: "text" }}
                      >
                        <TreeNode
                          title={
                            <strong style={{ paddingLeft: 5, color: "white" }}>Permisos</strong>
                          }
                          key={0}
                          disabled={false}
                          icon={
                            <Icon fontSize="small" color="primary">
                              lock
                            </Icon>
                          }
                        >
                          {Object.values(grupos).map((grupo) => {
                            const opciones = filter(permisos, (p) => {
                              return p.idGrupoPermiso === grupo.idGrupoPermiso;
                            });
                            return (
                              <TreeNode
                                title={
                                  <strong style={{ paddingLeft: 5, color: "white" }}>
                                    {grupo.grupoPermiso}
                                  </strong>
                                }
                                key={`P${grupo.idGrupoPermiso}`}
                                disabled={false}
                                icon={
                                  <Icon fontSize="small" color="primary">
                                    rule_folder
                                  </Icon>
                                }
                              >
                                {map(opciones, (permiso) => {
                                  const activado = filter(permisosAc, (e) => {
                                    return e === String(permiso.idPermiso);
                                  });
                                  return (
                                    <TreeNode
                                      title={
                                        <strong
                                          style={{
                                            paddingLeft: 5,
                                            color: activado.length == 0 ? "#606161" : "#4CAF50",
                                          }}
                                        >
                                          {permiso.permiso}
                                        </strong>
                                      }
                                      key={permiso.idPermiso}
                                      disabled={false}
                                      icon={
                                        <Icon
                                          fontSize="small"
                                          color={activado.length == 0 ? "secondary" : "success"}
                                        >
                                          key
                                        </Icon>
                                      }
                                    ></TreeNode>
                                  );
                                })}
                              </TreeNode>
                            );
                          })}
                        </TreeNode>
                      </Tree>
                    </MDBox>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
          <ModalContent
            title={"Cambio de rol"}
            maxWidth="sm"
            fullWidth={false}
            open={mostarModalConfirm}
            fullScreen={false}
            handleClose={() => {
              setMostarModalConfirm(false);
            }}
            handleAcept={() => {
              ConfirmarCambioRol();
              setMostarModalConfirm(false);
            }}
            textAccept={"Cambiar rol"}
          >
            <MDBox>
              <MDTypography variant="button" color="text" fontWeight="regular">
                Al cambiar el rol del usuario, sus permisos serán cambiados al del{" "}
                <strong>rol elegido</strong>
              </MDTypography>
            </MDBox>
          </ModalContent>

          <ModalContent
            title={"Restablecer contraseña"}
            maxWidth="sm"
            fullWidth={false}
            open={openmodalRestablecer}
            fullScreen={false}
            handleClose={() => {
              setopenmodalRestablecer(false);
            }}
            handleAcept={() => {
              dispatch(ResetearContrasena(state.idUsuario));
              setopenmodalRestablecer(false);
            }}
            textAccept={"Aceptar"}
          >
            <MDBox>
              <MDTypography variant="button" color="text" fontWeight="regular">
                Esta acción cambiará la contraseña actual del usuario por una nueva la cual será
                enviada al correo electrónico registrado.
              </MDTypography>
            </MDBox>
          </ModalContent>
        </MDBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}
